<template>
  <div class="mb-3">
    <h4 class="title">{{ $t('titles.yourMembership') }}</h4>
    <div v-if="newMembershipType">
      {{$t('messages.you_are_all_set')}}
    </div>
    <div class="mt-2 mb-0 membership">
      <span class="membership-title">{{ membership.membershipType.name }}</span>
      <span v-if="canCancel" class="membership-action">
        <SecondaryButton @click.prevent="cancelMembership" v-if="!membership.canceled">{{$t('buttons.stop_auto_renew')}}</SecondaryButton>
      </span>
      <span class="membership-action">
        <span v-if="showExtendAction">
          <SecondaryButton :enabled="isExtendable" @click.prevent="extendMembership">{{$t('buttons.extend')}}</SecondaryButton>
        </span>
        <span v-if="showUpgradeAction">
          <SecondaryButton :enabled="isSwitchable" @click.prevent="switchMembership">{{$t('buttons.upgrade')}}</SecondaryButton>
        </span>
      </span>

    </div>

    <div class="details">

      <template v-if="membership.status == 'one_time'">
        <template v-if="newMembershipType">
          <div>
            <span class="label">
              {{$t('labels.switch_to_membership', {membership: newMembershipType.name}) }}
            </span>
            <p>{{formatDate(membership.upgradeAt)}}</p>
          </div>
        </template>
        <div v-else-if="membership.validUntil">
          <span class="label">
            {{$t('labels.valid_until')}}
          </span>
          <p>{{formatDate(membership.validUntil)}}</p>
        </div>
      </template>

      <template v-else>
        <div v-if="membership.status == 'trialing'">
          <span class="label">
            {{$t('labels.trial_since')}}
          </span>
          <p>{{formatDate(membership.currentPeriodStart)}}</p>
        </div>
        <div v-else>
          <span class="label">
            {{$t('labels.active_since')}}
          </span>
          <p>{{formatDate(membership.currentPeriodStart)}}</p>
        </div>

        <template v-if="newMembershipType">
          <div>
            <span class="label">
              {{$t('labels.switch_to_membership', {membership: newMembershipType.name}) }}
            </span>
            <p>{{formatDate(membership.upgradeAt)}}</p>
          </div>
        </template>
        <template v-else>
          <div v-if="!membership.canceled">
            <span class="label">
              {{$t('labels.next_payment_date')}}
            </span>
            <p>{{formatDate(membership.currentPeriodEnd)}}</p>
          </div>
          <div v-if="membership.validUntil">
            <span class="label">
              {{$t('labels.cancel_date')}}
            </span>
            <p>{{formatDate(membership.validUntil)}}</p>
          </div>
        </template>
        <div>
          <payment-source v-bind="membership.stripePaymentSource" @edit-payment="editPayment" v-if="membership.stripePaymentSource"/>
        </div>
      </template>
    </div>
    <MembershipTypeDescription :membership-type="membership.membershipType"/>

    <AddToWalletButton
      :plasticCard="membership.plasticCard"
      message=""
      v-if="membership && membership.plasticCard"
    />

    <router-view></router-view>
  </div>
</template>

<script>
import PaymentSource from "./PaymentSource";
import SecondaryButton from "../buttons/SecondaryButton";
import MembershipTypeDescription from "./MembershipTypeDescription.vue";
import AddToWalletButton from "./wallet/AddToWalletButton.vue";

export default {
  components: { SecondaryButton, PaymentSource, MembershipTypeDescription, AddToWalletButton },
  computed: {
    branch: () => {
      return process.env.FG_APP_BRANCH
    },
    canCancel() {
      return this.membership.isCancellable && !this.newMembershipType
    },
    membership () {
      return this.$store.getters.currentUser.membership
    },
    newMembershipType() {
      return this.membership && this.membership.newMembershipType
    },
    isExtendable() {
      return this.membership.isExtendable && !this.newMembershipType
    },
    isSwitchable() {
      return this.membership.isSwitchable && !this.newMembershipType
    },
    showExtendAction() {
      return this.membership && this.membership.status == 'one_time'
    },
    showUpgradeAction() {
      // return this.membership && this.membership.status == 'one_time'
      return this.membership && !this.newMembershipType
    }
  },
  methods: {
    editPayment() {
      this.$router.push('/edit')
    },
    cancelMembership() {
      this.$router.push('/cancel')
    },
    switchMembership() {
      this.$router.push('/switch')
    },
    loadAllMemberships() {
      return Promise.all([
        this.$store.dispatch('listMembershipTypes', { inviteCodes: [] }),
        this.$store.dispatch('listMembershipTypes', { inviteCodes: this.$store.getters.inviteCodes })
      ]).then(([membershipTypes1, membershipTypes2]) => {
        const membershipTypes = membershipTypes1.concat(membershipTypes2);
        return membershipTypes;
      });
    },
    extendMembership() {
      this.loadAllMemberships()
          .then((membershipTypes) => {
            const foundMembershipType = membershipTypes.find(({id}) => id == this.membership.membershipType.id)
            this.$store.dispatch('selectMembershipType', foundMembershipType)
            this.$router.push(`/checkout/${foundMembershipType.id}`)
          })
    },

  },

}
</script>

<style scoped lang="scss">
.membership-container {
  width: 100%;
  margin-top: 30px;
}
h1 {
  margin-bottom: 3rem;
}

.membership {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .membership-title {
    flex-grow: 1;
  }
  .membership-action {
    padding-left: 10px;
    margin-top: -16px;
    margin-bottom: -16px;
    span:not(:last-child) {
      margin-right: 10px;
    }
  }

}



.details {
  margin-bottom: 1rem;
  //border-top: 1px solid $gray-2;
  & > div {
    //border-bottom: 1px solid $gray-2;
    display: flex;
    padding: 1rem 0 0 0;

    .label {
      flex-basis: 25%;
      padding-right: 12px;
      @media screen and (max-width: 750px) {
        flex-basis: 50%;
      }
      //font-family: $secondary-font-family;
      //font-weight: bold;
      //text-transform: uppercase;
      //font-size: 14px;
    }

    p {
      padding: 0;
      margin: 0;
      //font-size: 14px;
      //font-family: $secondary-font-family;
    }
  }
}


</style>


